import { Ticket } from 'lucide-react'
import { useUnreadMessagesQuery } from '../hooks/use-tickets-query'
import { SidebarMenuButton, useSidebar } from '@/components/ui/sidebar'
import { useTranslation } from 'react-i18next'
import { tokens } from '@/locales/translations/tokens'
import { useNavigate } from '@tanstack/react-router'
import { Badge } from '@/components/ui/badge'

interface UnreadTicketsBadgeProps {
  isActive?: boolean
  icon?: React.ElementType
}

export function UnreadTicketsBadge({
  isActive,
  icon,
}: UnreadTicketsBadgeProps) {
  const { state } = useSidebar()
  const { t } = useTranslation()
  const { data: unreadData } = useUnreadMessagesQuery()
  
  const unreadCount = unreadData?.data?.unread_count || 0
  const hasUnreadMessages = unreadCount > 0
  const IconComponent = icon || Ticket

  const navigate = useNavigate()

  return (
    <SidebarMenuButton
      isActive={isActive}
      tooltip={t(tokens.tickets.page.title)}
      className={`cursor-pointer ${state === 'collapsed' ? 'relative' : ''}`}
      onClick={() => navigate({ to: '/tickets' })}
    >
      <IconComponent className='h-4 w-4' />
      <span>{t(tokens.tickets.page.title)}</span>
      {hasUnreadMessages && state === 'expanded' && (
        <Badge
          variant='default'
          className='bg-notification-unread ml-auto rounded-full px-1.5 py-0 text-xs text-white hover:bg-red-600'
        >
          {unreadCount > 9 ? '9+' : unreadCount}
        </Badge>
      )}
      {hasUnreadMessages && state === 'collapsed' && (
        <div className='absolute right-0.5 top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-red-500 px-1 text-[8px] font-semibold text-white'>
          {unreadCount > 9 ? '9+' : unreadCount}
        </div>
      )}
    </SidebarMenuButton>
  )
}
